export var withInstall = function withInstall(component) {
  for (var _len = arguments.length, others = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    others[_key - 1] = arguments[_key];
  }
  var c = component;
  c.install = function (app) {
    var _ref, _c$name;
    for (var _len2 = arguments.length, options = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      options[_key2 - 1] = arguments[_key2];
    }
    app.component((_ref = (_c$name = c.name) !== null && _c$name !== void 0 ? _c$name : c.displayName) !== null && _ref !== void 0 ? _ref : c.__name, component);
    if (others) {
      others.forEach(function (item) {
        if (item !== null && item !== void 0 && item.install && typeof item.install === 'function') {
          app.use.apply(app, [item].concat(options));
        } else {
          var _ref2, _item$name;
          var compName = (_ref2 = (_item$name = item.name) !== null && _item$name !== void 0 ? _item$name : item.displayName) !== null && _ref2 !== void 0 ? _ref2 : item.__name;
          app.component(compName, item);
        }
      });
    }
  };
  return component;
};
export function withDeprecated(c, message) {
  var _install = c.install;
  c.install = function (app) {
    console.warn(message);
    for (var _len3 = arguments.length, options = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      options[_key3 - 1] = arguments[_key3];
    }
    _install(app, options);
  };
  return c;
}
export default {
  withInstall: withInstall,
  withDeprecated: withDeprecated
};